module.exports = __webpack_public_path__ + "media/application/images/2023/Headline INT-61b743eed81cb838dc9fada54a9c7718.png";